<template>
  <div class="Aboutus">
    <div class="bigImg">
      <div class="topInfo">
        <h3>What We OFFER</h3>
        <p>
          As direct publisher, we've been working with over 200 direct advertisers via a solid and <br/> healthypartnership from Europe, MENA SEA to LATAM.
        </p>
        <div>
          <span class="startBtn transformBtn" @click="goSignUp">Get Started</span>
          <span class="moreBtn transformBtn" @click="goVital('#vital')">More info</span>
        </div>
      </div>
    </div>
    <div class="centerBody">
      <div class="second" id="vital">
        <h3>Why Vertads ？</h3>
        <div class="whyBox">
          <div>
            <img src="../../static/aboutus/second1.png" alt="">
            <p>
              <span>In-house Developed Offers</span>
              <span>Get access to the top In-house developed RevShare and CPA offers. Byremoving the middle man we can get you the highest payouts.</span>
            </p>
          </div>
          <div>
            <img src="../../static/aboutus/second2.png" alt="">
            <p>
              <span>Reliable (Weekly) Payment</span>
              <span>Select your preferred payout method and we will make sure of atimely payout. Weekly payouts are supported!</span>
            </p>
          </div>
          <div>
            <img src="../../static/aboutus/second3.png" alt="">
            <p>
              <span>Dedicated Account Manager</span>
              <span>Need help getting started? Add your Account Manager on Skype and getdirect 24/7 personal support, useful tips and insigh</span>
            </p>
          </div>
          <div>
            <img src="../../static/aboutus/second4.png" alt="">
            <p>
              <span>5% Referral Bonus</span>
              <span>Earn something extra with minimal effort? Receive an extra 5% ofthe revenue of each user that signs up through your referral</span>
            </p>
          </div>
        </div>
      </div>
      <div class="mvas">
        <h3>MVAS Vertical</h3>
        <div>
          <p>
            <img src="../../static/aboutus/mvas1.png" alt="">
            <span>Games</span>
          </p>
          <p>
            <img src="../../static/aboutus/mvas2.png" alt="">
            <span>Lifestyle</span>
          </p>
          <p>
            <img src="../../static/aboutus/mvas3.png" alt="">
            <span>Video Streaming</span>
          </p>
          <p>
            <img src="../../static/aboutus/mvas4.png" alt="">
            <span>Education</span>
          </p>
          <p>
            <img src="../../static/aboutus/mvas5.png" alt="">
            <span>Fitness</span>
          </p>
          <p>
            <img src="../../static/aboutus/mvas6.png" alt="">
            <span>Crypto</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'Aboutus',
    data() {
      return{

      }
    },
    created(){
      // 传参控制显示顶部和底部
      this.$emit('controlShow', false);
    },
    methods:{
      goSignUp(){
        this.$store.commit('setMenuKey','4');
        this.$router.push({
          name: "signup"
        });
      },
      goVital(e){
        document.querySelector(e).scrollIntoView({
          behavior: "auto",
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .Aboutus{
    width: 100%;
    margin: 0 auto;
    .bigImg{
      width: 100%;
      height: 800px;
      background: url('../../static/aboutus/banner.png') no-repeat;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: center;
      .topInfo{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #fff;
        h3{
          font-size: 38px;
        }
        p{
          font-size: 16px;
          text-align: center;
          margin-bottom: 90px;
        }
        div{
          .startBtn{
            background-image: linear-gradient(to bottom, #E11F27 0%, #AE2025 100%,);
            margin-right: 80px;
          }
          .moreBtn{
            background-color: #fff !important;
            color: #CD2128;
          }
          span{
            width: 120px;
            height: 50px;
            border-radius: 8px;
            display: inline-block;
            text-align: center;
            line-height: 50px;
          }
        }
      }
    }
    .centerBody{
      width: 100%;
      box-sizing: border-box;
      padding: 80px 0;
      background: url('../../static/aboutus/background.png') no-repeat;
      background-size: 100% 100%;
      .second{
        width: 100%;
        h3{
          font-size: 38px;
          color: #000;
          text-align: center;
          margin: 0 0 100px;
        }
        .whyBox{
          width: 65%;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: center;
          margin: 0 auto;
          div{
            width: 40%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 125px;
            img{
              width: 80px;
              height: auto;
              margin-right: 35px;
            }
            p{
              font-size: 14px;
              display: flex;
              flex-direction: column;
              span:nth-child(1){
                font-size: 20px;
                color: #D42229;
                margin-bottom: 10px;
              }
            }
          }
        }
      }
      .mvas{
        width: 100%;
        margin-top: 150px;
        h3{
          font-size: 38px;
          color: #000;
          text-align: center;
          margin: 80px 0;
        }
        div{
          width: 55%;
          margin: 0 auto;
          display: flex;
          flex-wrap: wrap;
          p{
            width: 33%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-bottom: 100px;
            img{
              width: 90px;
              height: auto;
              margin-bottom: 24px;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 500px) {
    .Aboutus{
      box-sizing: border-box;
      padding-top: 40px;
      .bigImg{
        height: 186px;
        .topInfo{
          height: 100%;
          justify-content: flex-start;
          h3{
            font-size: 16px;
            margin-top: 30px;
          }
          p{
            font-size: 10px;
            text-align: center;
            margin-bottom: 20px;
          }
          div{
            .startBtn{
              margin-right: 60px;
            }
            span{
              width: 60px;
              height: 25px;
              border-radius: 4px;
              line-height: 25px;
              font-size: 10px;
            }
          }
        }
      }
      .centerBody{
        width: 100%;
        box-sizing: border-box;
        padding: 20px 0;
        background: url('../../static/wap/abouts/background.png') no-repeat;
        background-size: 100% 100%;
        .second{
          width: 100%;
          h3{
            font-size: 16px;
            color: #000;
            text-align: center;
            margin: 0 0 10px;
          }
          .whyBox{
            width: 90%;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;
            margin: 0 auto;
            div{
              width: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-bottom: 19px;
              img{
                width: 40px;
                height: auto;
                margin-right: 32px;
              }
              p{
                font-size: 10px;
                display: flex;
                flex-direction: column;
                line-height: 14px;
                span:nth-child(1){
                  font-size: 12px;
                  color: #D42229;
                  margin-bottom: 5px;
                  font-weight: 500;
                }
              }
            }
          }
        }
        .mvas{
          width: 100%;
          margin-top: 0px;
          h3{
            font-size: 16px;
            color: #000;
            text-align: center;
            margin: 10px 0;
          }
          div{
            width: 100%;
            margin: 0 auto;
            display: flex;
            flex-wrap: wrap;
            p{
              width: 33%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              margin-bottom: 20px;
              font-size: 12px;
              img{
                width: 25px;
                height: auto;
                margin-bottom: 12px;
              }
            }
          }
        }
      }
    }
  }
</style>